import * as TYPES from './constants';
import {API} from 'config/employer.config';
import {JWT_HEADER, JSON_HEADER} from 'config/srm.config';
import {
  requestTopProgramEnrollmentsList,
  receiveTopProgramEnrollmentsList,
  handleTopProgramEnrollmentsListError,
  clearTopProgramEnrollmentsList,
} from './actions';

const initialState = {
  data: null,
  error: false,
  request: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TYPES.TOP_PROGRAM_ENROLLMENT_LIST_REQUEST:
      return {
        ...state,
        request: true,
      };
    case TYPES.TOP_PROGRAM_ENROLLMENT_LIST_RECEIVE:
      return {
        ...state,
        request: false,
        data: action.payload,
      };
    case TYPES.TOP_PROGRAM_ENROLLMENT_LIST_ERROR:
      return {
        ...state,
        error: true,
        request: false,
      };
    case TYPES.CLEAR_TOP_PROGRAM_ENROLLMENT_LIST:
      return {
        ...initialState,
      };
    default:
      return state;
  }
};

export const fetchTopProgramEnrollmentsResults = () => (dispatch, getState) => {
  const {
    auth: {
      access: {token},
    },
  } = getState();
  const config = {
    mode: 'cors',
    method: 'GET',
    cache: 'default',
    headers: Object.assign({}, JWT_HEADER(token), JSON_HEADER),
  };
  dispatch(requestTopProgramEnrollmentsList());

  let URI = `${
    API.administration.emerging_talent
  }?program_enrollments=true&page=1&page_size=5&sort=enrollment_desc&career_area=all`;

  try {
    return fetch(URI, config)
      .then(response => response.json())
      .then(json => {
        dispatch(receiveTopProgramEnrollmentsList(json));
      })
      .catch(err => {
        console.log(err);
        dispatch(handleTopProgramEnrollmentsListError(err));
      });
  } catch (err) {
    console.log(err);
    dispatch(handleTopProgramEnrollmentsListError(err));
  }
};
